import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import './index.css';  

const NotFound = () => {
    return (
        <div className="notfound-container">
            <div className="notfound-content">
                <Result
                    status="404"
                    title="404"
                    subTitle="抱歉，您访问的页面不存在。"
                    extra={
                        <div className="notfound-actions">
                            <Link to="/">
                                <Button type="primary" size="large">
                                    返回首页
                                </Button>
                            </Link>
                            <Link to="/archive">
                                <Button size="large">
                                    浏览文章
                                </Button>
                            </Link>
                        </div>
                    }
                />
                <div className="notfound-suggestions">
                    <h3>您可以尝试：</h3>
                    <ul>
                        <li>检查网址是否正确</li>
                        <li>返回 <Link to="/">首页</Link> 重新导航</li>
                        <li>浏览我们的 <Link to="/archive">文章归档</Link></li>
                        <li>使用右上角的搜索功能</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default NotFound;